export interface Business {
  id: string;
  name: string;
  description: string;
  contact_email: string;
  contact_phone: string;
  services: string[];
  verified: boolean;
  created_at: string;
  address?: string;
  city?: string;
  province?: string;
  gallery?: string[];
  logo_url?: string;
  business_hours?: {
    [key: string]: string;
  };
  monthly_fee?: number;
}

export interface BusinessForm {
  name: string;
  description: string;
  contact_email: string;
  contact_phone: string;
  address: string;
  city: string;
  province: string;
  monthly_fee?: number;
}

export interface Analytics {
  totalInventory: number;
  lowStockItems: number;
  pendingBookings: number;
  monthlyBookings: number;
  completedBookings: number;
  revenue: number;
}

export interface Notification {
  id: string;
  type: 'info' | 'warning' | 'error' | 'success';
  title: string;
  message: string;
  timestamp: string;
  read: boolean;
}

export interface OpeningHours {
  monday: { open: string; close: string; closed: boolean };
  tuesday: { open: string; close: string; closed: boolean };
  wednesday: { open: string; close: string; closed: boolean };
  thursday: { open: string; close: string; closed: boolean };
  friday: { open: string; close: string; closed: boolean };
  saturday: { open: string; close: string; closed: boolean };
  sunday: { open: string; close: string; closed: boolean };
}

export const defaultOpeningHours: OpeningHours = {
  monday: { open: '08:00', close: '17:00', closed: false },
  tuesday: { open: '08:00', close: '17:00', closed: false },
  wednesday: { open: '08:00', close: '17:00', closed: false },
  thursday: { open: '08:00', close: '17:00', closed: false },
  friday: { open: '08:00', close: '17:00', closed: false },
  saturday: { open: '09:00', close: '13:00', closed: false },
  sunday: { open: '09:00', close: '13:00', closed: true }
};

export const availableServices = [
  'Tyre Fitting',
  'Wheel Alignment',
  'Wheel Balancing',
  'Mobile Service',
  'Emergency Service',
  'Run-flat Tyres',
  'Tyre Repairs',
  'Puncture Repairs',
  'Valve Replacements',
  'Tyre Rotation',
  'Pressure Checks',
  'Road Assistance'
];